export enum AssessmentModules {
  GlasgowComaScale = 'Glasgow Coma Scale',
  ImmediateMemory = 'Immediate Memory',
  NeckExam = 'Neck Exam',
  NeurologicalExam = 'Neurological Exam',
  SymptomChecklist = 'Symptom Checklist',
  DigitsBackwards = 'Digits Backwards',
  MonthsInReverse = 'Months in Reverse',
  BalanceTandemGait = 'Balance - Tandem Gait',
  BalanceDoubleLegStance = 'Balance - Double Leg Stance',
  BalanceSingleLegStance = 'Balance - Single Leg Stance',
  BalanceTandemStance = 'Balance - Tandem Stance',
  VOMS = 'Vestibular/Ocular-Motor Screening (VOMS) for Concussion',
  DelayedRecall = 'Delayed Recall',
  TreatmentPlan = 'Treatment Plan',
}
